/* eslint-disable jsx-a11y/alt-text */
import React, { useRef } from "react";
import BasicLayout from "./BasicLayout";
import { Link, useLocation } from "react-router-dom";

const LIST_MENU = [
  { name: "Trang chủ", link: "/", icon: <i class="fa-solid fa-house"></i> },
  {
    name: "Món ăn",
    link: "/San-pham",
    icon: <i class="fa-solid fa-utensils"></i>,
  },
  {
    name: "Set thực đơn",
    link: "/Set-thuc-don",
    icon: <i class="fa-solid fa-landmark"></i>,
  },
  {
    name: "Đầu bếp",
    link: "/Dau-bep",
    icon: <i class="fa-solid fa-chess-queen"></i>,
  },
  {
    name: "Liên hệ",
    link: "/Lien-he",
    icon: <i class="fa-solid fa-phone-volume"></i>,
  },
];

const Header = () => {
  const refListMenu = useRef();
  const refOveflow = useRef();
  const { pathname } = useLocation();

  const handleShowMenu = () => {
    refListMenu.current.classList.add("!translate-x-0");
    refOveflow.current.classList.remove("hidden");
  };

  const handleHiddenMenu = () => {
    refListMenu.current.classList.remove("!translate-x-0");
    refOveflow.current.classList.add("hidden");
  };
  return (
    <div className="bg-slate-200 fixed z-[9999999] top-0 left-0 right-0">
      <BasicLayout>
        <div className="flex  justify-between">
          <a
            href="/"
            className=" h-[70px] flex gap-[8px] lg:py-0 py-2 items-center"
          >
            <img
              className="rounded-[50%] border-[2px] border-amber-500"
              height="60px"
              width="60px"
              src="https://tse4.mm.bing.net/th?id=OIP.bHub4EFhHkxASSXkYgcUsgHaHa&pid=Api&P=0&h=220"
            />
            <div className="text-orange font-Poetsen font-bold flex-1 text-lg">
              <span className="block">Nấu Cỗ Hải Dương</span>
              <span>0584.564.666 </span>
            </div>
          </a>

          <div className="flex items-center max-md:hidden">
            {LIST_MENU.map((item, index) => {
              return (
                <Link key={index} to={item.link}>
                  <div
                    style={
                      pathname && pathname === item.link
                        ? { color: "#ff5d22" }
                        : null
                    }
                    className="lg:text-lg px-[16px] text-base font-semibold leading-[80px] hover:text-primary transition text-nowrap"
                  >
                    {item.name}
                  </div>
                </Link>
              );
            })}
          </div>
          <div
            onClick={handleShowMenu}
            className="hidden px-4 py-2 h-fit hover:bg-slate-100 rounded transition cursor-pointer max-md:block mt-2"
          >
            <i className="fa-solid fa-bars text-2xl "></i>
          </div>
        </div>
      </BasicLayout>

      <div className=" text-sm  text-[#fa0505e0] grad py-1 text-center px-1">
        <div className=" animate-pulse  max-md:block flex-center gap-1 font-semibold">
          <div>Dịch vụ nấu cỗ - Từ 1 đến 500 mâm - Ship từ 1 món</div>
          <div>(Uy tín - Phục vụ - Chuyên nghiệp)</div>
        </div>
      </div>

      <div
        onClick={handleHiddenMenu}
        ref={refOveflow}
        className="fixed top-0 right-0 bottom-0 left-0 bg-black opacity-60 z-40 hidden"
      ></div>
      <div
        ref={refListMenu}
        className="fixed top-0 left-[30%] right-0 bottom-0 bg-white z-50 translate-x-[100%]  transition"
      >
        <div
          onClick={handleHiddenMenu}
          className="absolute right-0 top-1 py-2 px-4 text-3xl cursor-pointer"
        >
          <i className="fa-solid fa-xmark"></i>
        </div>
        <div className="mt-[60px]">
          {LIST_MENU.map((item, index) => {
            return (
              <Link onClick={handleHiddenMenu} key={index} to={item.link}>
                <div
                  style={
                    pathname && pathname === item.link
                      ? { color: "#ff5d22", backgroundColor: "#f0f0f0" }
                      : null
                  }
                  className="lg:text-lg px-[12px] text-base font-semibold leading-[60px] hover:text-primary transition text-nowrap"
                >
                  <span className="mr-3 w-5 h-5 inline-block">{item.icon}</span>
                  <span>{item.name}</span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Header;
